import LoginComponent from "../../components/frontend/auth/LoginComponent";
import SignupComponent from "../../components/frontend/auth/SignupComponent.vue";
import ForgotPasswordComponent from "../../components/frontend/auth/ForgotPasswordComponent";
import ForgotPasswordVerifyComponent from "../../components/frontend/auth/ForgotPasswordVerifyComponent";
import ResetPasswordComponent from "../../components/frontend/auth/ResetPasswordComponent";
import SignupVerifyComponent from "../../components/frontend/auth/SignupVerifyComponent";

import TwoFactorVerifyComponent from "../../components/frontend/auth/TwoFactorVerifyComponent.vue";

export default [
    {
        path: '/login',
        component: LoginComponent,
        name: 'auth.login',
        meta: {
            isFrontend: true,
            auth: false
        }
    },
    {
        path: '/login/two-factor',
        component: TwoFactorVerifyComponent,
        name: 'auth.twoFactorVerify',
        props: true,
        meta: {
            isFrontend: true,
            auth: false
        }
    },
    {
        path: '/registro',
        component: SignupComponent,
        name: 'auth.signup',
        meta: {
            isFrontend: true,
            auth: false
        }
    },
    {
        path: '/registro/verificacion',
        component: SignupVerifyComponent,
        name: 'auth.signupVerify',
        meta: {
            isFrontend: true,
            auth: false
        }
    },
    {
        path: '/recuperar-password',
        component: ForgotPasswordComponent,
        name: 'auth.forgotPassword',
        meta: {
            isFrontend: true,
            auth: false
        }
    },
    {
        path: '/recuperar-password/verificacion',
        name: 'auth.forgotPasswordVerify',
        component: ForgotPasswordVerifyComponent,
        meta: {
            isFrontend: true,
            auth: false
        }
    },
    {
        path: '/recuperar-password/reset-password',
        name: 'auth.resetPassword',
        component: ResetPasswordComponent,
        meta: {
            isFrontend: true,
            auth: false
        }
    },

];
